import React, { useState } from "react";
import "./LoginStyle.scss";
import {useDispatch , useSelector} from "react-redux";
import { sendOtpcall,fetchResendOtp } from "../../Store/newUser/NewUserAction";
import * as newUserSelectors from "../../Store/newUser/NewUserSelector";
import { useNavigate } from "react-router-dom";

const ForgotPassword = ({ newUser }) => {
  const [contact, setContact] = useState("");
  const [contactRequiredError, setContactRequiredError] = useState(false);
  const errFromRedux = useSelector(newUserSelectors.getError);
  const errMessage = errFromRedux;
  console.log("contactRequiredError",contactRequiredError,errMessage);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sendOtpApicall = (contact) =>
  {
    const number = `+91`+contact;
    if(newUser === true)
    {
      dispatch(fetchResendOtp(number,newUser,navigate));
    }
    else{
    dispatch(sendOtpcall(number,newUser,navigate));
    }
  }
  const contactNumberChange = (e) => {
    setContact(e.value); // Use e.value to get the input value
    if (e.value === "") {
      setContactRequiredError(true);
    } else {
      setContactRequiredError(false);
    }
  };

  const handleSendOtp = () => {
    if (contact === "") {
      setContactRequiredError(true);
    } else {
      setContactRequiredError(false);
      sendOtpApicall(contact);
    }
  };
console.log("contactNumberChange",contactNumberChange,handleSendOtp);

  return (
    <>
      <div>
        <div className="text-blue-900 font-semibold text-4xl">
          {newUser ? "Reset Password  " : "Forgot Password ? "}
        </div>
        <div className="text-sm w-30rem" style={{ color: "black" }}>
          <strong>
            To get a new password, please write to MAATR support team
          </strong>
        </div>
        {/* <div className="text-500 text-sm w-30rem">
          {newUser
            ? "Don’t worry, enter your mobile number to receive an OTP (One Time Password)"
            : "Don't remember your password ? Dont't worry enter your mobile number to recieve an OTP (One Time Password)"}
        </div> */}
      </div>
      {/* <div className="flex">
        <p className="mr-1 mb-3" style={{ color: "#E03581" }}>
          {" "}
          *{" "}
        </p>
        <p>
          <label
            htmlFor="phone"
            className="text-blue-900 font-semibold"
            data-testid="mobile-no-label"
          >
            {" "}
            Mobile No.
          </label>
        </p>
      </div> */}
      {/* <div>
        <InputMask
          className="custom-input text-blue-800 w-30rem border-blue-800 mr-3 bg-white"
          id="phone"
          value={contact}
          mask="9999999999"
          placeholder="9999999999"
          data-testid="phone-input"
          prefix="+91"
          onChange={contactNumberChange}
        ></InputMask>
      </div>
      {contactRequiredError && (
        <div className="text-red-500" data-testid="mobile-no-error">Mobile No. is required</div>
      )}
      {errFromRedux ? <div className="text-red-500" data-testid="api-error">{errMessage}</div> : ""}
      <Button
        className="login-btn mt-4 w-30rem"
        onClick={handleSendOtp}
        data-testid="send-otp-button"
        disabled = {contactRequiredError}
         // Use disabled instead of disable
      >
        Send OTP
      </Button> */}
    </>
  );
};

export default ForgotPassword;
